module.exports = __webpack_public_path__ + "img/plus_btn.12e4e8f7.png";